import { ChangeDetectorRef, Component, Input, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { OptionsService, TypeTransmission } from '@lib/services/options.service';
import { OuiSelectOption } from 'omnium-ui/form-field';
import { AbstractSpecificDataComponent } from '../../abstract-specific-data.component';
import { TypeSignaturePartenaire } from '@lib/models/generated/graphql';
import { EnveloppeProduitService } from '@lib/services/enveloppe-produit.service';
import { ENVELOPPE_FONDS_USUFRUIT_CODE } from '@lib/models/box-additionnal-data';

const TRANSMISSION_KEY = 'transmissionOriginaux';

@Component({
    selector: 'app-type-signature-partenaire',
    templateUrl: './type-signature-partenaire.component.html',
    styleUrls: ['./type-signature-partenaire.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TypeSignaturePartenaireComponent extends AbstractSpecificDataComponent {
  @Input() override touchNonce?: number;
  transmissionListOptions: OuiSelectOption<string>[];
  metadata: any = {};
  override getDataName(): string {
    return 'typeSignaturePartenaire';
  }

  showTransmissionField: boolean = false;

  signatureOptions: OuiSelectOption<string>[] = [];
  signatureControl = new FormControl<TypeSignaturePartenaire | undefined>(undefined, [Validators.required]);
  transmissionControl = new FormControl<TypeTransmission | undefined>(undefined, [Validators.required]);

  enveloppeFondsUsufruitCode = ENVELOPPE_FONDS_USUFRUIT_CODE;

  constructor(
    private optionsService: OptionsService,
    private cdr: ChangeDetectorRef,
    private enveloppeProduitService: EnveloppeProduitService
  ) {
    super();

    this.signatureOptions = this.optionsService.getTypeSignaturePartenaireOptions();
    this.transmissionListOptions = this.optionsService.getTransmissionOptions();
  }

  override ngOnChanges(ch: SimpleChanges): void {
    super.ngOnChanges(ch);
  }

  ngOnInit() {
    // NOTE :This logic prevents users from selecting "ElectroniqueArianeUniversign" when the envelope type is SVP.
    // due to Business rule: Removing 'ElectroniqueArianeUniversign' is required when the envelope type is SVP.
    this.enveloppeProduitService.getEnveloppeSVPs().then(enveloppeSVPs => {
      if (enveloppeSVPs.includes(this.operation?.operationConfig?.enveloppeProduit?.code)) {
        this.signatureOptions = this.optionsService
          .getTypeSignaturePartenaireOptions()
          .filter(option => option.value !== TypeSignaturePartenaire.ElectroniqueArianeUniversign);
      } else if (this.operation?.operationConfig?.enveloppeProduit?.code === ENVELOPPE_FONDS_USUFRUIT_CODE) {
        /**
         * Note : This logic prevents users from selecting "ElectroniqueExtranetPartenaire" when the envelope type is FONDS d'USUFRUIT.
         * due to Business rule: Removing 'ElectroniqueExtranetPartenaire' is required when the envelope type is FONDS d'USUFRUIT.
         */
        this.signatureOptions = this.optionsService
          .getTypeSignaturePartenaireOptions()
          .filter(option => option.value !== TypeSignaturePartenaire.ElectroniqueExtranetPartenaire);
      } else {
        this.signatureOptions = this.optionsService.getTypeSignaturePartenaireOptions();
      }
      this.transmissionListOptions = this.optionsService.getTransmissionOptions();
      this.cdr.detectChanges();
    });

    this.signatureControl.valueChanges.subscribe(value => {
      this.showTransmissionField =
        value === TypeSignaturePartenaire.Manuscrite &&
        this.operation?.operationConfig?.enveloppeProduit?.code !== this.enveloppeFondsUsufruitCode;

      if (!this.showTransmissionField) {
        this.transmissionControl.setValue(undefined);
        this.transmissionControl.reset();
      } else {
        const envoi = this.initialData?.data[TRANSMISSION_KEY];
        if (envoi) {
          this.transmissionControl.setValue(envoi);
        }
      }

      // TODO voir pour éditer la valeur autre part ?
      this.operation!.typeSignaturePartenaire = value;
    });

    this.transmissionControl.valueChanges.subscribe(value => {
      this.metadata[TRANSMISSION_KEY] = value;

      this.onSpecificDataChanged.emit({
        dataSource: this.getDataName(),
        data: { isFormValid: this.isValidForm(), data: this.metadata },
      });
    });

    this.signatureControl.setValue(this.operation?.typeSignaturePartenaire);
  }

  marksAsTouched(): void {
    this.signatureControl.markAsTouched();
    this.transmissionControl.markAsTouched();
  }

  isValidForm(): boolean {
    const isSignatureOK = this.signatureControl.valid;
    return this.showTransmissionField ? isSignatureOK && this.transmissionControl.valid : isSignatureOK;
  }

  override markAllAsTouched(): void {
    this.signatureControl.markAllAsTouched();
    this.transmissionControl.markAllAsTouched();
  }
}
